import { useAtomValue, useSetAtom } from 'jotai'
import { useCallback } from 'react'
import { signupWithWallet } from 'src/common/api-clients/swarm/passport'
import useTier2 from 'src/common/queries/useTier2'
import { thirdwebCommonConnectConfig } from 'src/config/thirdweb'
import {
  kycModalAtom,
  verifyModalAtom,
} from 'src/pages/TradePage/stores/trade-store'
import { useConnectModal } from 'thirdweb/react'

export const useConnectWallet = () => {
  const { connect: thirdwebConnect } = useConnectModal()
  const { refetch: refetchTier2 } = useTier2()
  const kycModal = useAtomValue(kycModalAtom)
  const setVerifyModal = useSetAtom(verifyModalAtom)
  const connect = useCallback(async () => {
    try {
      const wallet = await thirdwebConnect({
        ...thirdwebCommonConnectConfig,
        size: 'compact',
        title: 'Sign up or Sign in',
        termsOfServiceUrl: 'https://docs.swarm.com/about/terms/tos',
      })
      const { new: isNew } = await signupWithWallet(wallet)
      if (wallet.getAccount()) {
        refetchTier2()
      }
      if (isNew && !kycModal) {
        setVerifyModal(true)
      }
      return wallet
    } catch {
      return undefined
    }
  }, [thirdwebConnect, kycModal, refetchTier2, setVerifyModal])

  return {
    connect,
  }
}
